"use strict";

angular.module("customer")
.directive("warnIncompleteProfile", function($rootScope, CUSTOMER_TYPE) {
    return {
        restrict: "AE",
        scope: false,
        templateUrl: require("./warn-incomplete-profile.directive.html"),
        controllerAs: "warnIncompleteProfileCtrl",
        controller: function($scope, $state, UserService) {
            $scope.displayWarning = false;
            $scope.displayLinkProfile = false;
            $scope.displayLinkCustomer = false;
            $scope.isCustomerTypeBusiness = true;

            function updateWarning(user) {
                if (user && user.has_profile_completed) {
                    $scope.displayWarning = !user.has_profile_completed["all"];
                    $scope.displayLinkProfile = !user.has_profile_completed["profile"];
                    $scope.displayLinkCustomer = !user.has_profile_completed["customer"];
                }
            }

            UserService.isUserFetched().then(function onSuccess(user) {
                updateWarning(user);
                if (user && user.customer) {
                    $scope.isCustomerTypeBusiness = user && user.customer && user.customer.type === CUSTOMER_TYPE["BUSINESS"];
                }
            });

            $scope.$on("UserUpdated", function(event, user) {
                updateWarning(user);
            });

            $scope.$on("UserLoggedOut", function() {
                $scope.displayWarning = false;
                $scope.displayLinkProfile = false;
                $scope.displayLinkCustomer = false;
            });

            this.goToProfileEdition = function() {
                $state.go("profile-edit");
            };

            this.goToCustomerEdition = function() {
                $state.go("customer-edit");
            };
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/full-profile-only/warn-incomplete-profile.directive.js
// module id = 828
// module chunks = 0